import { IVacancySection, IVacancySectionListItem, VacancySectionResponseType } from "./vacancy_section.types";

export default class VacancySection implements  IVacancySection {
    total: number;
    data: IVacancySectionListItem[] = [];
    constructor(data: VacancySectionResponseType) {
        this.total = data.total;
        for (let i = 0; i < data.data.length; i++) {
            this.data.push(data.data[i]);
        }
    }
}